import Quotatable from './QuotaTable';

export default Quotatable;
